document.addEventListener('DOMContentLoaded', () => {
  // Smooth scroll to anchor links accounting for sticky header
  function smoothScrollToAnchor(e) {
    const nav = performance.getEntriesByType("navigation")[0];
      if (nav && nav.type === "reload") return;
      
      const anchor = e.target.closest('a[href*="#"]');
      if (!anchor) return;

    const linkUrl = new URL(anchor.href);
    const currentUrl = new URL(window.location.href);

    if (linkUrl.pathname !== currentUrl.pathname || !anchor.hash) return;
    
    const targetElement = document.querySelector(anchor.hash);
    if (!targetElement) return;

    e.preventDefault();
    const header = document.querySelector('header[is="sticky-header"]');
    const headerHeight = header ? header.offsetHeight : 0;
    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: targetPosition - headerHeight,
      behavior: 'smooth'
    });
  }

  document.addEventListener('click', smoothScrollToAnchor);
});